export default __webpack_public_path__ + "static/media/img_awaiting_stream_jp.72f41ad8.jpg";